import { API_FACTORY } from '@connect-x-app/shared-utils';

import { HttpClient } from '../utils/http';

type Payload = {
  duration: string | null;
  muted: boolean;
  roomId: string;
};

export const muteFlightroom = ({ duration, muted, roomId }: Payload): Promise<void> =>
  HttpClient.patch(API_FACTORY.v3('users/muted-flightrooms'), { flightRoomId: roomId, hasMuted: muted, muteDuration: duration });
